/* Studio VormVezel – blog en blogartikel (layout vv laadt dit script op de blog- en artikelpagina).
   De pagina's zelf worden op de server opgebouwd (sections/vv-blog-main, sections/vv-article). Dit script regelt alleen
   de knop "In winkelwagen" in een productrij in een artikel (snippets/vv-article-pcard; demo: padd):
   - .pcard [data-quick-add="<variant-id>"], met data-name (productnaam en maat, voor de melding), optioneel data-qty
     (zakelijke klant met een minimum- of stapaantal: dat aantal in één keer, zoals de demo) en data-max (alleen bij lage
     voorraad: het aantal op voorraad).
   - Teksten uit de sectie Blogartikel, op [data-vv-post] (de .prose om de tekst): data-added, data-max-text,
     data-max-one-text en data-error.
   - Gelukt: melding voorlezen, tellertje bijwerken en de winkelwagen openen (window.vv.addToCart uit assets/vv.js).
   - Zit de hele voorraad al in de winkelwagen (data-max), of lukt toevoegen niet: de melding staat ruim 3 seconden op de
     knop zelf en wordt voorgelezen, zoals in de demo (maxMsg). De knop houdt de focus (geen disabled, wel aria-busy).
   Zonder dit script (of zonder vv.js) handelt assets/vv.js de knop af met 1 stuk.
   Alles via event delegation, dus ook na het opnieuw laden van een sectie in de thema-editor. */
(function () {
  'use strict';
  var D = document;

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/'; }
  function tok(s, map) {
    s = String(s || '');
    for (var k in map) { if (Object.prototype.hasOwnProperty.call(map, k)) s = s.split('[' + k + ']').join(map[k]); }
    return s;
  }
  function say(t) { if (t && window.vv && typeof window.vv.announce === 'function') window.vv.announce(t); }
  function text(btn, name, fallback) {
    var box = btn.closest('[data-vv-post]');
    var v = box ? box.getAttribute('data-' + name) : '';
    return v ? v : fallback;
  }
  /* Melding tijdelijk op de knop zelf (demo: data-orig) */
  function flash(btn, msg) {
    if (btn.hasAttribute('data-orig')) return;
    btn.setAttribute('data-orig', btn.innerHTML);
    btn.textContent = msg;
    setTimeout(function () {
      if (btn.hasAttribute('data-orig')) { btn.innerHTML = btn.getAttribute('data-orig'); btn.removeAttribute('data-orig'); }
    }, 3200);
  }
  /* Hoeveel van deze variant al in de winkelwagen zit (0 als dat niet lukt; Shopify controleert dan zelf) */
  function inCart(id) {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        var n = 0;
        ((c && c.items) || []).forEach(function (it) { if (Number(it.variant_id) === id) n += Number(it.quantity) || 0; });
        return n;
      })
      .catch(function () { return 0; });
  }

  /* Vangfase: vóór de algemene data-quick-add-afhandeling van vv.js, die dan niet meer meedoet */
  D.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.pcard [data-quick-add]') : null;
    if (!b || !window.vv || typeof window.vv.addToCart !== 'function' || !window.fetch || !window.Promise) return;
    e.preventDefault();
    e.stopPropagation();
    if (b.disabled || b.getAttribute('aria-busy') === 'true' || b.hasAttribute('data-orig')) return;

    var id = Number(b.getAttribute('data-quick-add'));
    var qty = parseInt(b.getAttribute('data-qty'), 10);
    var max = parseInt(b.getAttribute('data-max'), 10);
    if (!id) return;
    if (!qty || qty < 1) qty = 1;

    b.setAttribute('aria-busy', 'true');
    b.classList.add('loading');
    (max > 0 ? inCart(id) : Promise.resolve(0))
      .then(function (n) {
        if (max > 0 && n + qty > max) {
          return { full: max === 1 ? text(b, 'max-one-text', 'Je hebt het laatste stuk dat op voorraad is al in je winkelwagen.') : tok(text(b, 'max-text', 'Je hebt alle [aantal] stuks die op voorraad zijn al in je winkelwagen.'), { aantal: max }) };
        }
        return window.vv.addToCart([{ id: id, quantity: qty }], true).then(function () { return { ok: true }; });
      })
      .then(function (res) {
        if (res && res.full) { say(res.full); flash(b, res.full); return; }
        say(tok(text(b, 'added', 'Toegevoegd aan je winkelwagen: [product].'), { product: b.getAttribute('data-name') || '' }));
        b.classList.add('added', 'is-added');
        setTimeout(function () { b.classList.remove('added', 'is-added'); }, 1600);
      })
      .catch(function (err) {
        /* 422 = Shopify weigert het aantal (voorraad, zakelijke regel): die uitleg tonen; anders de eigen tekst */
        var msg = err && err.status === 422 && typeof err.description === 'string' && err.description ? err.description : text(b, 'error', 'Toevoegen lukte niet. Probeer het nog eens.');
        say(msg);
        flash(b, msg);
      })
      .then(function () {
        b.removeAttribute('aria-busy');
        b.classList.remove('loading');
      });
  }, true);
})();
